/**
 * Severity levels for the centralized alert/notification system.
 *
 * - Use these values to classify the urgency and visual style of user-facing alerts (UI banners, toasts, modals).
 * - Also used for event grouping in Sentry and reporting/analytics pipelines.
 *
 * Consuming systems:
 *   - UI: Maps to icon color, alert style, and available actions.
 *   - API/Support: Used as a signal for escalation or ticket routing.
 *   - Sentry: Tag events for analysis and deduplication.
 *
 * Only these string values should be used in frontend and API payloads pertaining to alerts.
 */
export enum AlertSeverityEnum {
  /** Critical errors: require immediate attention or action by the user/admin. */
  Critical = 'critical',

  /** Warning: indicates potential issues or situations that need attention but are not urgent. */
  Warning = 'warning',

  /** Informational: non-urgent notices, tips, or status updates. */
  Info = 'info',
}
